<template>
       <div class="templateDoctorPh">
            <h4 class=" text-center text-secondary pt-5"> ဆရာဝန်များကို ဖုန်းခေါ်ဆိုအကူအညီရယူရန် </h4>
             <div class="row m-5">
                        <div class=" col-md-5 mx-auto d-block card m-3 p-4 card-glass " v-for="doctorph in doctorphs" :key="doctorph.id">
                                <div class="card-body">
                                    <h5 class="card-title text-danger"> {{ doctorph.name }}</h5>
                                    <div class="row mt-3">
                                        <div class="col-md-6 ">
                                                <div class="row">
                                                            <div class="col">
                                                                    <span class="link-dark">ဖုန်း - </span>
                                                            </div>
                                                            <div class="col">
                                                                        <div class="mb-1">
                                                                            <a  :href="'tel:'+doctorph.ph" class=" text-decoration-none">  {{doctorph.ph}}</a> 
                                                                        </div>

                                                                        <div class="mb-1">
                                                                            <a  :href="'tel:'+doctorph.ph1" class=" text-decoration-none">  {{doctorph.ph1}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+doctorph.ph2" class=" text-decoration-none">   {{doctorph.ph2}}</a> 
                                                                        </div>

                                                                            <div class="mb-1">
                                                                            <a  :href="'tel:'+doctorph.ph3" class=" text-decoration-none">  {{doctorph.ph3}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+doctorph.ph4" class=" text-decoration-none">  {{doctorph.ph4}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a  :href="'tel:'+doctorph.ph5"  class=" text-decoration-none"> {{doctorph.ph5}}</a> 
                                                                        </div>
                                                                           <div>
                                                                            <a  :href="'tel:'+doctorph.ph6" class=" text-decoration-none">  {{doctorph.ph7}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+doctorph.ph7"  class=" text-decoration-none"> {{doctorph.ph7}}</a> 
                                                                        </div>
                                                            </div>

                                                    </div>
                                                  
                                            </div>
                                              <small class="text-muted mt-2"> ဖုန်းနံပါတ်ကိုနှိပ်ပြီးခေါ်ဆိုနိုင်ပါသည် </small>

                                               <div class="col-md-6 mt-3 ">
                                                    <small class=""> {{ doctorph.note}} </small>
                                            </div>
                                    </div>
                                  
                                   
                                 
                                    
                                </div>
                        </div>      

            </div>        
           
        </div>
          
</template>

<script>
export default {
    name: "Doctorph",

    data(){
        return {
    doctorphs : [
        {name:'Charity C-19 call Center', ph:'+959779110001' , ph1:'+959779110002', ph2:'+959779110003',ph3:'+959779110004', ph4:'+959779110006'},
        {name:'Yangon Medical Network' , ph:'+959757521712', ph1:'+959757521713'}

        
    ]
    }

    }

   
}
</script>

<style>
       .templateDoctorPh {
          min-height: 100vh;
          background:linear-gradient(to right top, #f7e9be, #e2e8e9);
          overflow: hidden;
     
          align-items: center;
          justify-content: center;
          
        }
</style>